import HeaderThemeDetector from './header-theme-detector';

class HeaderThemeManager {
	constructor() {
		this.header = document.querySelector('#site-header');
		this.detector = new HeaderThemeDetector({
			onThemeChange: (theme) => this.applyTheme(theme),
		});
	}

	init() {
		if (!this.header) {
			return;
		}

		this.detector.init();
	}

	applyTheme(theme) {
		this.header.classList.toggle('is-dark', theme === 'dark');
	}
}

const headerThemeManager = new HeaderThemeManager();
headerThemeManager.init();
